/*
|
|               Client
_______________________________________________
|
|    This class keep all fields for 
|    new client. 
|
*/

export class Client {
    BillingStreet                  :string  = '';
    BillingCity                    :string  = '';
    BillingState                   :string  = '';
    BillingZipCode                 :string  = '';
    BillingCountry                 :string  = '';
    Company                        :string  = '';
    DisplayNameAs                  :any     = '';
    Email                          :string  = '';
    Fax                            :string  = '';
    FirstName                      :string  = '';
    id                             :any     = '';
    LastName                       :string  = '';
    MiddleName                     :string  = '';
    Mobile                         :string  = '';
    Notes                          :string  = '';
    Other                          :string  = '';
    Phone                          :string  = '';
    Position                       :any     = '';
    referredBy                     :any     = '';
    SameAsBillingAddress           :boolean = true;
    ShippingStreet                 :string  = '';
    ShippingCity                   :string  = '';
    ShippingState                  :string  = '';
    ShippingZipCode                :string  = '';
    ShippingCountry                :string  = '';
    Suffix                         :string  = '';
    Supplier                       :string  = '';
    suppliers?                     :any[];
    SupplierAccountNumber          :string  = '';
    Title                          :string  = '';
    Website                        :string  = '';

}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/Client.ts